import { useEffect } from 'react';
import { GameState } from '../domain/entities';
import { View } from '../App';
import { getPlayerTeam, findTeamInState } from '../services/GameService';
import { setAccentColors, setPlayerHeaderColor, getCurrentTheme, setThemeMode } from '../utils/theme';
import { setMainAccentColor, setTeamAccentColor, resetTeamAccentColor } from '../utils/accentColorUtils';

export const useTheme = (gameState: GameState | { gameStarted: false }, currentView: View) => {

    useEffect(() => {
        const savedTheme = getCurrentTheme();
        const savedFont = localStorage.getItem('psm_font') || "'Silkscreen', sans-serif";
        const savedFontSize = localStorage.getItem('psm_fontSize') || '12px';

        setThemeMode(savedTheme);
        document.documentElement.style.setProperty('--font-family', savedFont);
        document.documentElement.style.setProperty('--font-size', savedFontSize);
    }, []);

    useEffect(() => {
        if (!gameState.gameStarted) {
            setAccentColors(undefined); // Reset to default colors
            setPlayerHeaderColor(undefined);
            return;
        }

        const playerTeam = getPlayerTeam(gameState);
        const playerPrimary = playerTeam?.colors?.primary || '#00ff9b';

        // ALWAYS set main accent to player's team color
        // This keeps the header, sidebar, and main game UI consistent
        setMainAccentColor(playerPrimary);

        // Legacy function calls for backward compatibility
        setAccentColors(playerTeam?.colors);
        setPlayerHeaderColor(playerTeam?.colors);

        // Set team accent color based on currently viewed team
        // If viewing a team/opposition page, use that team's colors
        // Otherwise, reset to match the main accent (player's team)
        if (currentView.teamName) {
            const viewedTeamData = findTeamInState(gameState, currentView.teamName);
            if (viewedTeamData) {
                // Use the viewed team's primary color for content accent
                const teamPrimary = viewedTeamData.team.colors.primary || '#00ff9b';
                setTeamAccentColor(teamPrimary);
            } else {
                // If team not found, reset to main accent
                resetTeamAccentColor();
            }
        } else {
            // Reset team accent to main when not viewing a team detail
            resetTeamAccentColor();
        }

    }, [gameState, currentView, document.documentElement.className]);
};
